export default "__VITE_ASSET__0f37bbbc__"